import Image from 'next/image';
import { FC } from 'react';
// import { HeaderProps } from '../Header';
// import { useHeaderContext } from '../HeaderContext';
import styles from './HeaderLogoBlock.module.scss';

export interface HeaderLogoBlockProps {
  logo?: {
    logo_image?: {
      url?: string;
    };
    logo_link?: {
      href?: string;
    };
    open_in_new_tab?: boolean;
  };
}

export const HeaderLogoBlock: FC<HeaderLogoBlockProps> = props => {
  const { logo } = props;
  const logoUrl = logo?.logo_image?.url ?? '';
  const logoLink = logo?.logo_link?.href ?? '';
  const openInNewTab = logo?.open_in_new_tab || null;

  const handleLogoGA = (href: any) => {
    window?.dataLayer?.push({
      event: 'buttonClick',
      buttonTitle: 'Logo',
      destinationUrl: href,
      pageURL: window.location.href,
      componentName: 'Logo'
    });
  };

  return (
    <div className={styles.Logo}>
      <a
        href={`https://www.fwd.com.hk${logoLink}`}
        target={openInNewTab ? '_blank' : ''}
        onClick={() => handleLogoGA(logoLink)}
      >
        <Image
          // src={
          //   'https://www.fwd.com.hk/-/media/global/images/fwdlogod.svg?rev=a209dbca469647fa89f47c76a00dc55c'
          // }
          src={
            logoUrl ??
            'https://www.fwd.com.hk/-/media/global/images/fwdlogod.svg?rev=a209dbca469647fa89f47c76a00dc55c'
          }
          alt="logo"
          className={styles.FWDLogo}
          // fill={true}
          width={96}
          height={35}
        />
      </a>
    </div>
  );
};
